document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('[data-caris-menu-toggle]');
  var panel = document.querySelector('[data-caris-mobile-panel]');
  var header = document.querySelector('[data-caris-header]');

  function setMenuState(open) {
    if (!panel || toggles.length === 0) return;
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.classList.toggle('is-open', open);
    });
    panel.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('caris-menu-open', open);
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  if (toggles.length && panel) {
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = panel.classList.contains('is-open');
        setMenuState(!isOpen);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setMenuState(false);
    });

    document.addEventListener('click', function (event) {
      if (!panel || !panel.classList.contains('is-open')) return;
      var clickedToggle = event.target.closest('[data-caris-menu-toggle]');
      var clickedInsidePanel = panel.contains(event.target);
      var clickedInsideHeader = header && header.contains(event.target);
      if (!clickedToggle && !clickedInsidePanel && !clickedInsideHeader) setMenuState(false);
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setMenuState(false);
      });
    });
  }

  document.querySelectorAll('[data-caris-auto-submit]').forEach(function (control) {
    control.addEventListener('change', function () {
      if (control.form) control.form.submit();
    });
  });

});


// Phase 5 product interactions: gallery, zoom, variant chips, quantity stepper and mobile sticky submit.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-caris-product-gallery]').forEach(function (gallery) {
    var panels = gallery.querySelectorAll('[data-caris-media-panel]');
    var thumbs = gallery.querySelectorAll('[data-caris-media-thumb]');
    function activateMedia(index) {
      panels.forEach(function (panel) { panel.classList.toggle('is-active', panel.getAttribute('data-caris-media-panel') === String(index)); });
      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-caris-media-thumb') === String(index);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activateMedia(thumb.getAttribute('data-caris-media-thumb')); });
    });

    var modal = gallery.querySelector('[data-caris-zoom-modal]');
    var modalImage = gallery.querySelector('[data-caris-zoom-image]');
    var close = gallery.querySelector('[data-caris-zoom-close]');
    function closeZoom() {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.documentElement.classList.remove('caris-zoom-open');
      if (modalImage) {
        modalImage.removeAttribute('src');
        modalImage.setAttribute('alt', '');
      }
    }
    gallery.querySelectorAll('[data-caris-zoom-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!modal || !modalImage) return;
        modalImage.src = button.getAttribute('data-zoom-src') || '';
        modalImage.alt = button.getAttribute('data-zoom-alt') || '';
        modal.removeAttribute('hidden');
        document.documentElement.classList.add('caris-zoom-open');
      });
    });
    if (close) close.addEventListener('click', closeZoom);
    if (modal) {
      modal.addEventListener('click', function (event) { if (event.target === modal) closeZoom(); });
    }
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeZoom(); });
  });

  document.querySelectorAll('[data-caris-product-root]').forEach(function (root) {
    var form = root.querySelector('.caris-product-form');
    var select = root.querySelector('[data-caris-product-select]');
    var stickyBar = document.querySelector('[data-caris-sticky-product-bar]');
    var stickyButton = stickyBar ? stickyBar.querySelector('[data-caris-sticky-submit]') : null;
    var stickyVariant = stickyBar ? stickyBar.querySelector('[data-caris-sticky-variant]') : null;
    var addButton = root.querySelector('[data-caris-add-button]');

    function updateVariant(id, title) {
      if (select) {
        select.value = id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      root.querySelectorAll('[data-caris-variant-chip]').forEach(function (chip) {
        var active = chip.getAttribute('data-variant-id') === String(id);
        chip.classList.toggle('is-selected', active);
        chip.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      if (stickyVariant) stickyVariant.textContent = title || '';
    }

    root.querySelectorAll('[data-caris-variant-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        updateVariant(chip.getAttribute('data-variant-id'), chip.getAttribute('data-variant-title'));
      });
    });

    root.querySelectorAll('[data-caris-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-caris-quantity]');
      var minus = stepper.querySelector('[data-caris-qty-minus]');
      var plus = stepper.querySelector('[data-caris-qty-plus]');
      function setQty(value) {
        var qty = parseInt(value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        input.value = qty;
      }
      if (minus && input) minus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) - 1); });
      if (plus && input) plus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) + 1); });
      if (input) input.addEventListener('change', function () { setQty(input.value); });
    });

    if (stickyButton && form) {
      stickyButton.addEventListener('click', function () {
        if (addButton && addButton.disabled) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  });
});


// Phase 6 cart drawer: open/close, AJAX add-to-bag and drawer quantity updates.
document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-caris-cart-drawer]');
  var overlay = document.querySelector('[data-caris-cart-shell] [data-caris-cart-close].caris-cart-drawer-overlay');
  var closeButtons = document.querySelectorAll('[data-caris-cart-close]');
  var openButtons = document.querySelectorAll('[data-caris-cart-open]');
  var ajaxEnabled = document.body && document.body.classList.contains('caris-ajax-cart-enabled');

  function setCartCount(count) {
    document.querySelectorAll('[data-caris-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
    document.querySelectorAll('[data-caris-cart-open]').forEach(function (el) {
      el.setAttribute('aria-label', 'Shopping bag with ' + count + ' items');
    });
  }

  function openDrawer() {
    drawer = document.querySelector('[data-caris-cart-drawer]');
    overlay = document.querySelector('[data-caris-cart-shell] [data-caris-cart-close].caris-cart-drawer-overlay');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.removeAttribute('hidden');
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      document.documentElement.classList.add('caris-cart-open');
    });
  }

  function closeDrawer() {
    drawer = document.querySelector('[data-caris-cart-drawer]');
    overlay = document.querySelector('[data-caris-cart-shell] [data-caris-cart-close].caris-cart-drawer-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('caris-cart-open');
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
      if (overlay) overlay.setAttribute('hidden', '');
    }, 320);
  }

  function bindDrawerQuantity() {
    document.querySelectorAll('[data-caris-drawer-qty]').forEach(function (button) {
      if (button.dataset.carisBound === 'true') return;
      button.dataset.carisBound = 'true';
      button.addEventListener('click', function () {
        var line = button.getAttribute('data-line');
        var quantity = parseInt(button.getAttribute('data-quantity'), 10);
        changeCartLine(line, quantity);
      });
    });
  }

  function refreshDrawer(openAfter) {
    drawer = document.querySelector('[data-caris-cart-drawer]');
    if (!drawer) return Promise.resolve();
    var sectionUrl = drawer.getAttribute('data-section-url') || ((window.CarisTheme && window.CarisTheme.cartUrl ? window.CarisTheme.cartUrl : '/cart') + '?section_id=caris-cart-drawer');
    return fetch(sectionUrl, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('[data-caris-cart-drawer]');
        var newOverlay = temp.querySelector('[data-caris-cart-shell] [data-caris-cart-close].caris-cart-drawer-overlay');
        var currentShell = document.querySelector('[data-caris-cart-shell]');
        var newShell = temp.querySelector('[data-caris-cart-shell]');
        if (currentShell && newShell) {
          currentShell.replaceWith(newShell);
        } else if (drawer && newDrawer) {
          drawer.replaceWith(newDrawer);
        }
        drawer = document.querySelector('[data-caris-cart-drawer]');
        overlay = document.querySelector('[data-caris-cart-shell] [data-caris-cart-close].caris-cart-drawer-overlay');
        var count = parseInt(drawer ? drawer.getAttribute('data-cart-count') : '0', 10) || 0;
        setCartCount(count);
        bindCartControls();
        bindDrawerQuantity();
        if (openAfter) openDrawer();
      });
  }

  function changeCartLine(line, quantity) {
    var url = (window.CarisTheme && window.CarisTheme.cartChangeUrl) || '/cart/change';
    return fetch(url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    }).then(function () { return refreshDrawer(true); }).catch(function () { window.location.href = (window.CarisTheme && window.CarisTheme.cartUrl) || '/cart'; });
  }

  function bindCartControls() {
    closeButtons = document.querySelectorAll('[data-caris-cart-close]');
    closeButtons.forEach(function (button) {
      if (button.dataset.carisCloseBound === 'true') return;
      button.dataset.carisCloseBound = 'true';
      button.addEventListener('click', closeDrawer);
    });
    document.querySelectorAll('[data-caris-cart-open]').forEach(function (button) {
      if (button.dataset.carisOpenBound === 'true') return;
      button.dataset.carisOpenBound = 'true';
      button.addEventListener('click', function (event) {
        if (!drawer) return;
        event.preventDefault();
        openDrawer();
      });
    });
  }

  bindCartControls();
  bindDrawerQuantity();
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeDrawer(); });

  if (ajaxEnabled) {
    document.querySelectorAll('form.caris-product-form').forEach(function (form) {
      if (form.dataset.carisAjaxBound === 'true') return;
      form.dataset.carisAjaxBound = 'true';
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter || document.activeElement;
        if (!submitter || submitter.getAttribute('name') !== 'add') return;
        event.preventDefault();
        var addUrl = (window.CarisTheme && window.CarisTheme.cartAddUrl) || '/cart/add';
        fetch(addUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () { return refreshDrawer(true); })
          .catch(function () {
            if (window.CarisAnnounce) window.CarisAnnounce('This item is not currently available to purchase.');
          });
      });
    });
  }


  var cookieBanner = document.querySelector('[data-caris-cookie-banner]');
  if (cookieBanner) {
    var cookieKey = 'caris_cookie_notice_dismissed';
    var acceptedKey = 'caris_cookie_notice_accepted';
    var dismissed = false;
    try { dismissed = window.localStorage.getItem(cookieKey) === 'true'; } catch (error) { dismissed = false; }
    if (!dismissed) cookieBanner.removeAttribute('hidden');

    function closeCookieBanner(accepted) {
      cookieBanner.setAttribute('hidden', '');
      try {
        window.localStorage.setItem(cookieKey, 'true');
        if (accepted) window.localStorage.setItem(acceptedKey, 'true');
      } catch (error) {}
    }

    cookieBanner.querySelectorAll('[data-caris-cookie-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () { closeCookieBanner(false); });
    });
    cookieBanner.querySelectorAll('[data-caris-cookie-accept]').forEach(function (button) {
      button.addEventListener('click', function () { closeCookieBanner(true); });
    });
  }

});


// Phase 10 customer experience: browser wishlist and address form toggles.
document.addEventListener('DOMContentLoaded', function () {
  var wishlistKey = 'caris_wishlist_items';

  function readWishlist() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) { return []; }
  }

  function writeWishlist(items) {
    try { window.localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (error) {}
  }

  function itemFromButton(button) {
    return {
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      url: button.getAttribute('data-product-url'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price')
    };
  }

  function isSaved(handle) {
    return readWishlist().some(function (item) { return item.handle === handle; });
  }

  function refreshWishlistButtons() {
    document.querySelectorAll('[data-caris-wishlist-toggle]').forEach(function (button) {
      var saved = isSaved(button.getAttribute('data-product-handle'));
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function toggleWishlist(button) {
    var product = itemFromButton(button);
    if (!product.handle) return;
    var items = readWishlist();
    var existingIndex = items.findIndex(function (item) { return item.handle === product.handle; });
    if (existingIndex >= 0) items.splice(existingIndex, 1);
    else items.unshift(product);
    writeWishlist(items);
    refreshWishlistButtons();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-caris-wishlist-grid]');
    var empty = document.querySelector('[data-caris-wishlist-empty]');
    if (!grid) return;
    var items = readWishlist();
    grid.innerHTML = '';
    if (empty) empty.hidden = items.length > 0;
    if (!items.length) return;
    items.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'caris-wishlist-item';
      var imageMarkup = item.image ? '<img src="' + item.image + '" alt="' + (item.title || 'Saved Caris product').replace(/"/g, '&quot;') + '">' : '<div class="caris-product-card__fallback"></div>';
      article.innerHTML =
        '<a class="caris-wishlist-item__media" href="' + item.url + '">' + imageMarkup + '</a>' +
        '<div class="caris-wishlist-item__info">' +
          '<a class="caris-wishlist-item__title" href="' + item.url + '">' + item.title + '</a>' +
          '<div class="caris-wishlist-item__price">' + (item.price || '') + '</div>' +
          '<div class="caris-wishlist-item__actions"><a class="caris-button caris-button--ghost" href="' + item.url + '">View</a><button class="caris-wishlist-remove" type="button" data-remove-handle="' + item.handle + '">Remove</button></div>' +
        '</div>';
      grid.appendChild(article);
    });
    grid.querySelectorAll('[data-remove-handle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-remove-handle');
        writeWishlist(readWishlist().filter(function (item) { return item.handle !== handle; }));
        refreshWishlistButtons();
        renderWishlistPage();
      });
    });
  }

  document.querySelectorAll('[data-caris-wishlist-toggle]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(button);
    });
  });
  refreshWishlistButtons();
  renderWishlistPage();

  document.querySelectorAll('[data-caris-toggle-address]').forEach(function (button) {
    button.addEventListener('click', function () {
      var targetId = button.getAttribute('data-caris-toggle-address');
      var target = document.getElementById(targetId);
      if (!target) return;
      target.hidden = !target.hidden;
    });
  });
});


// Phase 11 UX hardening: live announcements, focus containment, image defaults and mobile polish.
document.addEventListener('DOMContentLoaded', function () {
  var settings = document.body ? document.body.classList : null;
  var liveRegion = document.querySelector('[data-caris-live-region]');

  function announce(message) {
    if (!message) return;
    if (liveRegion) {
      liveRegion.textContent = '';
      window.setTimeout(function () { liveRegion.textContent = message; }, 30);
    }
    var toast = document.querySelector('[data-caris-js-announcement]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'caris-js-announcement';
      toast.setAttribute('data-caris-js-announcement', '');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._carisTimer);
    toast._carisTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  window.CarisAnnounce = announce;

  if (document.body && document.body.classList.contains('caris-performance-polish')) {
    document.querySelectorAll('img').forEach(function (img) {
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      if (!img.hasAttribute('loading') && !img.closest('.caris-logo-link') && !img.classList.contains('caris-header-logo')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  }

  if (document.body && document.body.classList.contains('caris-mobile-safe-spacing')) {
    document.documentElement.style.setProperty('--caris-viewport-height', window.innerHeight + 'px');
    window.addEventListener('resize', function () {
      document.documentElement.style.setProperty('--caris-viewport-height', window.innerHeight + 'px');
    }, { passive: true });
  }

  if (document.body && document.body.classList.contains('caris-touch-targets')) {
    document.querySelectorAll('.caris-mobile-panel a, .caris-header-actions a, .caris-menu-toggle, button').forEach(function (el) {
      el.classList.add('caris-tap-target');
    });
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), details summary, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && !el.closest('[hidden]'); });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab' || !container) return;
    var focusable = getFocusable(container);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  if (!settings || document.body.classList.contains('caris-keyboard-traps-disabled')) return;

  document.addEventListener('keydown', function (event) {
    var openZoom = document.querySelector('[data-caris-zoom-modal]:not([hidden]) .caris-zoom-modal__inner');
    var openCart = document.querySelector('[data-caris-cart-drawer].is-open');
    var openMenu = document.querySelector('[data-caris-mobile-panel]:not([hidden])');
    if (openZoom) trapTab(event, openZoom);
    else if (openCart) trapTab(event, openCart);
    else if (openMenu) trapTab(event, openMenu);
  });

  var focusObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target;
      if (!(target instanceof HTMLElement)) return;
      if ((target.matches('[data-caris-cart-drawer]') && target.classList.contains('is-open')) ||
          (target.matches('[data-caris-mobile-panel]') && !target.hasAttribute('hidden')) ||
          (target.matches('[data-caris-zoom-modal]') && !target.hasAttribute('hidden'))) {
        window.setTimeout(function () {
          var focusable = getFocusable(target);
          if (focusable.length && !target.contains(document.activeElement)) focusable[0].focus();
        }, 60);
      }
    });
  });

  document.querySelectorAll('[data-caris-cart-drawer], [data-caris-mobile-panel], [data-caris-zoom-modal]').forEach(function (el) {
    focusObserver.observe(el, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden'] });
  });

  document.querySelectorAll('[data-caris-product-gallery]').forEach(function (gallery) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-caris-media-thumb]'));
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var nextIndex = event.key === 'ArrowRight' ? index + 1 : index - 1;
        if (nextIndex < 0) nextIndex = thumbs.length - 1;
        if (nextIndex >= thumbs.length) nextIndex = 0;
        thumbs[nextIndex].focus();
        thumbs[nextIndex].click();
      });
    });
  });

  var countNode = document.querySelector('[data-caris-cart-count]');
  if (countNode) {
    var previousCount = countNode.textContent.trim();
    var countObserver = new MutationObserver(function () {
      var nextCount = countNode.textContent.trim();
      if (nextCount !== previousCount) {
        previousCount = nextCount;
        announce(nextCount ? 'Shopping bag updated ' + nextCount : 'Shopping bag is empty');
      }
    });
    countObserver.observe(countNode, { childList: true, characterData: true, subtree: true });
  }

  if (document.body && document.body.classList.contains('caris-performance-polish') && document.body.classList.contains('caris-loading-state-enabled')) {
    window.addEventListener('load', function () {
      document.body.classList.add('is-caris-loaded');
    });
  }
});


// Phase 12 final polish: compact header and soft reveal states.
document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  if (!body || !body.classList.contains('caris-final-polish')) return;

  var header = document.querySelector('[data-caris-header]');
  var shrinkEnabled = body.classList.contains('caris-header-shrink-enabled');
  function updateHeaderState() {
    if (!header || !shrinkEnabled) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  }
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  if (body.classList.contains('caris-reveal-enabled') && 'IntersectionObserver' in window && !body.classList.contains('caris-reduced-motion')) {
    var revealItems = document.querySelectorAll('.caris-section, .caris-page-hero, .caris-product-card, .caris-tile, .caris-signoff-card');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-caris-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index % 6, 5) * 55 + 'ms';
      observer.observe(item);
    });
  } else {
    document.querySelectorAll('.caris-section, .caris-page-hero, .caris-product-card, .caris-tile, .caris-signoff-card').forEach(function (item) {
      item.classList.add('is-caris-revealed');
    });
  }

  document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
    if (!link.getAttribute('rel')) link.setAttribute('rel', 'noopener noreferrer');
  });
});


// Phase 13 release candidate helpers.
document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  if (!body) return;
  var releaseBar = document.querySelector('.caris-release-bar');
  if (releaseBar) {
    releaseBar.setAttribute('title', 'Internal Caris release status. Disable in Theme settings before public launch.');
  }
});


// Caris v5.0 entry intro: homepage only, once per browser session, then fades into the site.
document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('[data-caris-intro-overlay]');
  if (!overlay) return;

  var isHomepage = window.location.pathname === '/' || window.location.pathname === '';
  var storageKey = 'caris_intro_seen_this_session_v1';
  var duration = 3000;
  var fade = 900;
  var video = overlay.querySelector('[data-caris-intro-video]');
  var skip = overlay.querySelector('[data-caris-intro-skip]');
  var timeoutId;

  function markSeen() {
    try { window.sessionStorage.setItem(storageKey, 'true'); } catch (e) {}
  }

  function hasSeen() {
    try { return window.sessionStorage.getItem(storageKey) === 'true'; } catch (e) { return false; }
  }

  function hideIntro() {
    window.clearTimeout(timeoutId);
    markSeen();
    overlay.classList.add('is-fading');
    document.documentElement.classList.remove('caris-intro-active');
    if (video) {
      try { video.pause(); } catch (e) {}
    }
    window.setTimeout(function () {
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-hidden', 'true');
    }, fade);
  }

  if (!isHomepage || hasSeen()) {
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('aria-hidden', 'true');
    return;
  }

  markSeen();
  overlay.removeAttribute('hidden');
  overlay.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('caris-intro-active');

  if (video) {
    try { video.currentTime = 0; } catch (e) {}
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }
  if (skip) skip.addEventListener('click', hideIntro);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !overlay.hasAttribute('hidden')) hideIntro();
  });
  timeoutId = window.setTimeout(hideIntro, duration);
});


// Caris v6.2 protected forms: submits Contact and Waiting List forms through Cloudflare Worker after Turnstile verification.
document.addEventListener('DOMContentLoaded', function () {
  function endpointFor(form) {
    var base = (form.getAttribute('data-caris-worker-endpoint') || '').replace(/\/$/, '');
    var type = form.getAttribute('data-caris-form-type') || 'contact';
    if (!base) return '';
    return base + '/' + encodeURIComponent(type);
  }

  function setFeedback(form, message, state) {
    var feedback = form.querySelector('[data-caris-form-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.hidden = !message;
    feedback.classList.toggle('is-success', state === 'success');
    feedback.classList.toggle('is-error', state === 'error');
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[data-caris-submit]');
    if (button) {
      button.disabled = !!busy;
      if (!button.getAttribute('data-caris-original-label')) button.setAttribute('data-caris-original-label', button.textContent);
      button.textContent = busy ? 'Please wait…' : button.getAttribute('data-caris-original-label');
    }
  }

  document.querySelectorAll('[data-caris-protected-form]').forEach(function (form) {
    var started = form.querySelector('[data-caris-started-at]');
    if (started) started.value = String(Date.now());

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setFeedback(form, '', '');

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var url = endpointFor(form);
      if (!url) {
        setFeedback(form, 'This form is not configured yet. Please contact Caris directly by email.', 'error');
        return;
      }

      var data = new FormData(form);
      var token = data.get('cf-turnstile-response') || '';
      if (!token) {
        setFeedback(form, 'Please complete the verification check and try again.', 'error');
        return;
      }

      var payload = {};
      data.forEach(function (value, key) { payload[key] = value; });
      payload.formType = form.getAttribute('data-caris-form-type') || 'contact';
      payload.pageUrl = window.location.href;
      payload.userAgent = navigator.userAgent;
      payload.turnstileToken = token;

      setBusy(form, true);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (json) {
          if (!response.ok || !json.ok) throw new Error(json.message || 'The form could not be sent. Please try again.');
          return json;
        });
      }).then(function (json) {
        form.reset();
        if (started) started.value = String(Date.now());
        if (window.turnstile) {
          form.querySelectorAll('.cf-turnstile').forEach(function (widget) {
            try { window.turnstile.reset(widget); } catch (e) {}
          });
        }
        setFeedback(form, json.message || 'Thank you. Your submission has been received.', 'success');
      }).catch(function (error) {
        if (window.turnstile) {
          form.querySelectorAll('.cf-turnstile').forEach(function (widget) {
            try { window.turnstile.reset(widget); } catch (e) {}
          });
        }
        setFeedback(form, error.message || 'Something went wrong. Please try again.', 'error');
      }).finally(function () {
        setBusy(form, false);
      });
    });
  });
});
